import React from "react";

export const Socket = (unique_id, group_name) => {
  const REACT_APP_SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
  const ws = new WebSocket(
    `${REACT_APP_SOCKET_URL}?group_name=${group_name}&unique_id=${unique_id}`
  );
  console.log("Grooup and unique id", group_name, unique_id);
  ws.onopen = () => {
    console.log("WebSocket Connected");
  };
  ws.onclose = () => {
    console.log("WebSocket Closed");
  };
  ws.onerror = (err) => {
    console.log("WebSocket Error", err);
  };
  return ws;
};
